import { createTranslations } from '@/i18n/types';

export default createTranslations({
  en: {
    login: 'Log in',
    profileTitle: 'Profile',
    profileReason: 'Log in to view your profile, balance, statistics and activity history.',
    upgradeTitle: 'Upgrade',
    upgradeReason: 'Log in to upgrade your skins. Pick your skin and try to get a more valuable one.',
    contractsTitle: 'Contracts',
    contractsReason: 'Log in to exchange several of your items for a single new one. The more your items are worth, the higher the contract stake.',
    inventoryTitle: 'Inventory',
    inventoryReason: 'Log in to see your skins. Sell, withdraw to Steam, send to upgrade or contracts.',
    referralsTitle: 'Friends',
    referralsReason: 'Log in to invite friends and earn a share of their drops. Your referral link will appear here.',
    paymentTitle: 'Top up balance',
    paymentReason: 'Log in to top up your SHOT balance and unlock case opening, contracts and upgrades.',
    caseOpenTitle: 'Open the case',
    caseOpenReason: 'Log in to open cases. Your won items go straight to your inventory.',
    caseBattleCreateTitle: 'Create a case battle',
    caseBattleCreateReason: 'Log in to challenge friends to a case battle. Stake your coins, the highest drop wins everything.',
    rushMidTitle: 'Rush Mid',
    rushMidReason: 'Log in to play Rush Mid — turn-based PvP matches against players on the same ticket.',
    rushMidSurveyTitle: 'Rush Mid survey',
    rushMidSurveyReason: 'Log in to take the Rush Mid survey and help make the game better.',
    rouletteTitle: 'Roulette',
    rouletteReason: 'Log in to play roulette — one round, one bank, the odds are equal for everyone.',
    bandTitle: 'SHOT BAND',
    bandReason: 'Log in to join SHOT BAND — a members club with cashback, daily quests and a weekly knife raffle.',
  },
  ru: {
    login: 'Войти',
    profileTitle: 'Профиль',
    profileReason: 'Войди, чтобы посмотреть свой профиль, баланс, статистику и историю активности.',
    upgradeTitle: 'Upgrade',
    upgradeReason: 'Войди, чтобы прокачивать свои предметы. Выбери свой скин и попробуй получить более ценный.',
    contractsTitle: 'Контракты',
    contractsReason: 'Войди, чтобы обменивать несколько своих предметов на один новый. Чем дороже сумма твоих предметов — тем выше ставка контракта.',
    inventoryTitle: 'Инвентарь',
    inventoryReason: 'Войди, чтобы посмотреть свои скины. Продавай, выводи в Steam, отправляй в апгрейд или контракты.',
    referralsTitle: 'Друзья',
    referralsReason: 'Войди, чтобы приглашать друзей и получать долю с их выпадений. Здесь появится твоя реферальная ссылка.',
    paymentTitle: 'Пополнение баланса',
    paymentReason: 'Войди, чтобы пополнить баланс SHOT и открывать кейсы, контракты, апгрейды.',
    caseOpenTitle: 'Открыть кейс',
    caseOpenReason: 'Войди, чтобы открывать кейсы. Выигранные предметы сразу попадут в твой инвентарь.',
    caseBattleCreateTitle: 'Создать кейс-баттл',
    caseBattleCreateReason: 'Войди, чтобы вызвать друзей на кейс-баттл. Ставь монеты, самый дорогой дроп забирает всё.',
    rushMidTitle: 'Rush Mid',
    rushMidReason: 'Войди, чтобы играть в Rush Mid — пошаговые PvP-матчи с игроками на том же билете.',
    rushMidSurveyTitle: 'Опрос по Rush Mid',
    rushMidSurveyReason: 'Войди, чтобы пройти опрос по Rush Mid и помочь сделать игру лучше.',
    rouletteTitle: 'Рулетка',
    rouletteReason: 'Войди, чтобы играть в рулетку — один раунд, один банк, шансы у всех равны.',
    bandTitle: 'SHOT BAND',
    bandReason: 'Войди, чтобы вступить в SHOT BAND — клуб с кешбэком, ежедневными заданиями и еженедельным розыгрышем ножа.',
  },
  uz: {
    login: 'Kirish',
    profileTitle: 'Profil',
    profileReason: 'Profilingiz, balansingiz, statistikangiz va faollik tarixini koʻrish uchun kiring.',
    upgradeTitle: 'Upgrade',
    upgradeReason: 'Skinlaringizni apgreyd qilish uchun kiring. Skiningizni tanlab, qimmatroq skinni olishga urining.',
    contractsTitle: 'Kontraktlar',
    contractsReason: 'Bir nechta predmetingizni bittasiga almashtirish uchun kiring. Predmetlar qiymati qancha yuqori boʻlsa, kontrakt stavkasi shuncha yuqori boʻladi.',
    inventoryTitle: 'Inventar',
    inventoryReason: 'Skinlaringizni koʻrish uchun kiring. Sotib, Steamga chiqarib, apgreyd yoki kontraktlarga yuboring.',
    referralsTitle: 'Doʻstlar',
    referralsReason: 'Doʻstlarni taklif qilish va ularning yutuqlaridan ulush olish uchun kiring. Sizning referal havolangiz shu yerda paydo boʻladi.',
    paymentTitle: 'Balansni toʻldirish',
    paymentReason: 'SHOT balansingizni toʻldirib, keyslar ochish, kontraktlar va apgreyd uchun kiring.',
    caseOpenTitle: 'Keysni ochish',
    caseOpenReason: 'Keyslarni ochish uchun kiring. Yutib olingan predmetlar darhol inventaringizga tushadi.',
    caseBattleCreateTitle: 'Keys jang yaratish',
    caseBattleCreateReason: 'Doʻstlaringizni keys jangiga chaqirish uchun kiring. Tangalaringizni tikib, eng qimmat drop hammasini oladi.',
    rushMidTitle: 'Rush Mid',
    rushMidReason: 'Rush Mid oʻynash uchun kiring — bir xil biletli oʻyinchilarga qarshi navbatma-navbat PvP matchlar.',
    rushMidSurveyTitle: 'Rush Mid soʻrovnomasi',
    rushMidSurveyReason: 'Rush Mid soʻrovnomasini toʻldirish va oʻyinni yaxshilashga yordam berish uchun kiring.',
    rouletteTitle: 'Ruletka',
    rouletteReason: 'Ruletka oʻynash uchun kiring — bitta raund, bitta bank, imkoniyatlar hamma uchun teng.',
    bandTitle: 'SHOT BAND',
    bandReason: 'Keshbek, kunlik topshiriqlar va haftalik pichoq lotereyasi bilan SHOT BAND klubiga qoʻshilish uchun kiring.',
  },
  fa: {
    login: 'ورود',
    profileTitle: 'پروفایل',
    profileReason: 'وارد شو تا پروفایل، موجودی، آمار و تاریخچه فعالیتت را ببینی.',
    upgradeTitle: 'ارتقا',
    upgradeReason: 'وارد شو تا اسکین‌هایت را ارتقا بدهی. اسکینت را انتخاب کن و شانست را برای یکی گران‌تر امتحان کن.',
    contractsTitle: 'قراردادها',
    contractsReason: 'وارد شو تا چند آیتمت را با یک آیتم تازه عوض کنی. هرچه آیتم‌هایت گران‌تر باشند، سطح قرارداد بالاتر می‌رود.',
    inventoryTitle: 'انبار',
    inventoryReason: 'وارد شو تا اسکین‌هایت را ببینی. بفروش، به استیم برداشت کن، به ارتقا یا قرارداد بفرست.',
    referralsTitle: 'دوستان',
    referralsReason: 'وارد شو تا دوستانت را دعوت کنی و از دراپ‌هایشان سهم بگیری. لینک دعوتت همین‌جا ظاهر می‌شود.',
    paymentTitle: 'شارژ موجودی',
    paymentReason: 'وارد شو تا موجودی SHOT را شارژ کنی و باز کردن کیس، قرارداد و ارتقا را باز کنی.',
    caseOpenTitle: 'کیس را باز کن',
    caseOpenReason: 'وارد شو تا کیس باز کنی. آیتم‌هایی که می‌بری مستقیم به انبارت می‌روند.',
    caseBattleCreateTitle: 'ساخت نبرد کیس',
    caseBattleCreateReason: 'وارد شو تا دوستانت را به نبرد کیس دعوت کنی. سکه بگذار وسط، گران‌ترین دراپ همه‌چیز را می‌برد.',
    rushMidTitle: 'Rush Mid',
    rushMidReason: 'وارد شو تا Rush Mid بازی کنی — نبردهای نوبتی PvP با بازیکنانی که هم‌بلیت تو هستند.',
    rushMidSurveyTitle: 'نظرسنجی Rush Mid',
    rushMidSurveyReason: 'وارد شو تا در نظرسنجی Rush Mid شرکت کنی و به بهتر شدن بازی کمک کنی.',
    rouletteTitle: 'رولت',
    rouletteReason: 'وارد شو تا رولت بازی کنی — یک دور، یک بانک، شانس برای همه برابر.',
    bandTitle: 'SHOT BAND',
    bandReason: 'وارد شو تا به SHOT BAND بپیوندی — باشگاه اعضا با کش‌بک، مأموریت‌های روزانه و قرعه‌کشی هفتگی چاقو.',
  },
  pt: {
    login: 'Entrar',
    profileTitle: 'Perfil',
    profileReason: 'Entre para ver seu perfil, saldo, estatísticas e histórico de atividade.',
    upgradeTitle: 'Upgrade',
    upgradeReason: 'Entre para fazer upgrade das suas skins. Escolha uma skin e tente conseguir uma mais valiosa.',
    contractsTitle: 'Contratos',
    contractsReason: 'Entre para trocar vários itens seus por um novo. Quanto maior o valor dos seus itens, maior o nível do contrato.',
    inventoryTitle: 'Inventário',
    inventoryReason: 'Entre para ver suas skins. Venda, saque para a Steam, mande para upgrade ou contratos.',
    referralsTitle: 'Amigos',
    referralsReason: 'Entre para convidar amigos e ganhar uma parte dos drops deles. Seu link de indicação vai aparecer aqui.',
    paymentTitle: 'Depositar',
    paymentReason: 'Entre para depositar no seu saldo SHOT e abrir caixas, contratos e upgrades.',
    caseOpenTitle: 'Abrir a caixa',
    caseOpenReason: 'Entre para abrir caixas. Os itens que ganhar vão direto para o seu inventário.',
    caseBattleCreateTitle: 'Criar uma batalha de caixas',
    caseBattleCreateReason: 'Entre para desafiar amigos para uma batalha de caixas. Coloque moedas na entrada, o drop mais caro leva tudo.',
    rushMidTitle: 'Rush Mid',
    rushMidReason: 'Entre para jogar Rush Mid — partidas PvP por turnos contra jogadores com o mesmo ingresso.',
    rushMidSurveyTitle: 'Pesquisa sobre o Rush Mid',
    rushMidSurveyReason: 'Entre para responder à pesquisa sobre o Rush Mid e ajudar a melhorar o jogo.',
    rouletteTitle: 'Roleta',
    rouletteReason: 'Entre para jogar roleta — uma rodada, um banco, chances iguais para todos.',
    bandTitle: 'SHOT BAND',
    bandReason: 'Entre para fazer parte do SHOT BAND — um clube com cashback, missões diárias e sorteio semanal de faca.',
  },
  tr: {
    login: 'Giriş yap',
    profileTitle: 'Profil',
    profileReason: 'Profilini, bakiyeni, istatistiklerini ve etkinlik geçmişini görmek için giriş yap.',
    upgradeTitle: 'Upgrade',
    upgradeReason: 'Skinlerini upgrade etmek için giriş yap. Skinini seç ve daha değerlisini almayı dene.',
    contractsTitle: 'Kontratlar',
    contractsReason: 'Birkaç eşyanı tek bir yeni eşyayla takas etmek için giriş yap. Eşyalarının toplam değeri ne kadar yüksekse, kontratın seviyesi o kadar yüksek.',
    inventoryTitle: 'Envanter',
    inventoryReason: "Skinlerini görmek için giriş yap. Sat, Steam'e çek, upgrade'e ya da kontrata gönder.",
    referralsTitle: 'Arkadaşlar',
    referralsReason: 'Arkadaşlarını davet edip droplarından pay almak için giriş yap. Davet linkin burada görünecek.',
    paymentTitle: 'Bakiye yükle',
    paymentReason: 'SHOT bakiyeni yüklemek ve kasa, kontrat, upgrade açmak için giriş yap.',
    caseOpenTitle: 'Kasayı aç',
    caseOpenReason: 'Kasa açmak için giriş yap. Kazandığın eşyalar doğrudan envanterine düşer.',
    caseBattleCreateTitle: 'Kasa savaşı oluştur',
    caseBattleCreateReason: 'Arkadaşlarını kasa savaşına çağırmak için giriş yap. Coinlerini girişe koy, en pahalı drop hepsini alır.',
    rushMidTitle: 'Rush Mid',
    rushMidReason: 'Rush Mid oynamak için giriş yap — aynı biletteki oyunculara karşı sıra tabanlı PvP maçlar.',
    rushMidSurveyTitle: 'Rush Mid anketi',
    rushMidSurveyReason: 'Rush Mid anketini doldurup oyunu daha iyi hale getirmeye yardım etmek için giriş yap.',
    rouletteTitle: 'Rulet',
    rouletteReason: 'Rulet oynamak için giriş yap — bir raund, bir banka, şanslar herkes için eşit.',
    bandTitle: 'SHOT BAND',
    bandReason: "SHOT BAND'e katılmak için giriş yap — cashback, günlük görevler ve haftalık bıçak çekilişi olan bir kulüp.",
  },
  uk: {
    login: 'Увійти',
    profileTitle: 'Профіль',
    profileReason: 'Увійди, щоб переглянути свій профіль, баланс, статистику та історію активності.',
    upgradeTitle: 'Upgrade',
    upgradeReason: 'Увійди, щоб прокачувати свої скіни. Обери скін і спробуй отримати цінніший.',
    contractsTitle: 'Контракти',
    contractsReason: 'Увійди, щоб обмінювати кілька своїх предметів на один новий. Чим дорожча сума твоїх предметів — тим вищий рівень контракту.',
    inventoryTitle: 'Інвентар',
    inventoryReason: 'Увійди, щоб переглянути свої скіни. Продавай, виводь у Steam, відправляй в апгрейд або контракти.',
    referralsTitle: 'Друзі',
    referralsReason: 'Увійди, щоб запрошувати друзів і отримувати частку з їхніх дропів. Тут з’явиться твоє реферальне посилання.',
    paymentTitle: 'Поповнення балансу',
    paymentReason: 'Увійди, щоб поповнити баланс SHOT і відкривати кейси, контракти й апгрейди.',
    caseOpenTitle: 'Відкрити кейс',
    caseOpenReason: 'Увійди, щоб відкривати кейси. Виграні предмети одразу потраплять до твого інвентаря.',
    caseBattleCreateTitle: 'Створити кейс-батл',
    caseBattleCreateReason: 'Увійди, щоб викликати друзів на кейс-батл. Заплати монетами за вхід — найдорожчий дроп забирає все.',
    rushMidTitle: 'Rush Mid',
    rushMidReason: 'Увійди, щоб грати в Rush Mid — покрокові PvP-матчі з гравцями на тому самому квитку.',
    rushMidSurveyTitle: 'Опитування про Rush Mid',
    rushMidSurveyReason: 'Увійди, щоб пройти опитування про Rush Mid і допомогти зробити гру кращою.',
    rouletteTitle: 'Рулетка',
    rouletteReason: 'Увійди, щоб грати в рулетку — один раунд, один банк, шанси в усіх рівні.',
    bandTitle: 'SHOT BAND',
    bandReason: 'Увійди, щоб вступити до SHOT BAND — клубу з кешбеком, щоденними завданнями та щотижневим розіграшем ножа.',
  },
  de: {
    login: 'Einloggen',
    profileTitle: 'Profil',
    profileReason: 'Logge dich ein, um dein Profil, dein Guthaben, deine Statistik und deinen Aktivitätsverlauf zu sehen.',
    upgradeTitle: 'Upgrade',
    upgradeReason: 'Logge dich ein, um deine Skins aufzuwerten. Wähl deinen Skin und versuch, einen wertvolleren zu bekommen.',
    contractsTitle: 'Contracts',
    contractsReason: 'Logge dich ein, um mehrere deiner Items gegen ein neues zu tauschen. Je mehr deine Items wert sind, desto höher ist die Stufe des Contracts.',
    inventoryTitle: 'Inventar',
    inventoryReason: 'Logge dich ein, um deine Skins zu sehen. Verkaufen, nach Steam auszahlen, ins Upgrade oder in Contracts schicken.',
    referralsTitle: 'Freunde',
    referralsReason: 'Logge dich ein, um Freunde einzuladen und einen Anteil an ihren Drops zu bekommen. Hier erscheint dein Empfehlungslink.',
    paymentTitle: 'Guthaben aufladen',
    paymentReason: 'Logge dich ein, um dein SHOT-Guthaben aufzuladen und Cases, Contracts und Upgrades zu nutzen.',
    caseOpenTitle: 'Case öffnen',
    caseOpenReason: 'Logge dich ein, um Cases zu öffnen. Gewonnene Items landen direkt in deinem Inventar.',
    caseBattleCreateTitle: 'Case Battle erstellen',
    caseBattleCreateReason: 'Logge dich ein, um Freunde zu einem Case Battle herauszufordern. Zahle den Eintritt in Münzen – der wertvollste Drop holt alles.',
    rushMidTitle: 'Rush Mid',
    rushMidReason: 'Logge dich ein, um Rush Mid zu spielen – rundenbasierte PvP-Matches gegen Spieler mit demselben Ticket.',
    rushMidSurveyTitle: 'Rush-Mid-Umfrage',
    rushMidSurveyReason: 'Logge dich ein, um an der Rush-Mid-Umfrage teilzunehmen und das Spiel besser zu machen.',
    rouletteTitle: 'Roulette',
    rouletteReason: 'Logge dich ein, um Roulette zu spielen – eine Runde, eine Bank, gleiche Chancen für alle.',
    bandTitle: 'SHOT BAND',
    bandReason: 'Logge dich ein, um SHOT BAND beizutreten – ein Club mit Cashback, täglichen Quests und wöchentlicher Messer-Verlosung.',
  },
  es: {
    login: 'Iniciar sesión',
    profileTitle: 'Perfil',
    profileReason: 'Inicia sesión para ver tu perfil, tu saldo, tus estadísticas y tu historial de actividad.',
    upgradeTitle: 'Upgrade',
    upgradeReason: 'Inicia sesión para mejorar tus skins. Elige un skin e intenta conseguir uno más valioso.',
    contractsTitle: 'Contratos',
    contractsReason: 'Inicia sesión para cambiar varios de tus objetos por uno nuevo. Cuanto más valgan tus objetos, mayor será el nivel del contrato.',
    inventoryTitle: 'Inventario',
    inventoryReason: 'Inicia sesión para ver tus skins. Véndelos, retíralos a Steam o mándalos a upgrade o a contratos.',
    referralsTitle: 'Amigos',
    referralsReason: 'Inicia sesión para invitar a amigos y recibir una parte de sus drops. Aquí aparecerá tu enlace de referido.',
    paymentTitle: 'Recargar saldo',
    paymentReason: 'Inicia sesión para recargar tu saldo de SHOT y abrir cajas, hacer contratos y upgrades.',
    caseOpenTitle: 'Abrir la caja',
    caseOpenReason: 'Inicia sesión para abrir cajas. Los objetos que consigas irán directo a tu inventario.',
    caseBattleCreateTitle: 'Crear un Case Battle',
    caseBattleCreateReason: 'Inicia sesión para retar a tus amigos a un Case Battle. Paga la entrada con monedas: el drop más valioso se lo lleva todo.',
    rushMidTitle: 'Rush Mid',
    rushMidReason: 'Inicia sesión para jugar a Rush Mid: partidas PvP por turnos contra jugadores con el mismo ticket.',
    rushMidSurveyTitle: 'Encuesta de Rush Mid',
    rushMidSurveyReason: 'Inicia sesión para responder la encuesta de Rush Mid y ayudar a mejorar el juego.',
    rouletteTitle: 'Ruleta',
    rouletteReason: 'Inicia sesión para jugar a la ruleta: una ronda, un bote y las mismas probabilidades para todos.',
    bandTitle: 'SHOT BAND',
    bandReason: 'Inicia sesión para unirte a SHOT BAND, un club con cashback, misiones diarias y un sorteo semanal de un cuchillo.',
  },
  pl: {
    login: 'Zaloguj się',
    profileTitle: 'Profil',
    profileReason: 'Zaloguj się, aby zobaczyć swój profil, saldo, statystyki i historię aktywności.',
    upgradeTitle: 'Upgrade',
    upgradeReason: 'Zaloguj się, aby ulepszać swoje skiny. Wybierz skin i spróbuj zdobyć cenniejszy.',
    contractsTitle: 'Kontrakty',
    contractsReason: 'Zaloguj się, aby wymieniać kilka swoich przedmiotów na jeden nowy. Im więcej warte są twoje przedmioty, tym wyższy poziom kontraktu.',
    inventoryTitle: 'Ekwipunek',
    inventoryReason: 'Zaloguj się, aby zobaczyć swoje skiny. Sprzedawaj je, wypłacaj na Steam, wysyłaj do upgrade’u lub kontraktów.',
    referralsTitle: 'Znajomi',
    referralsReason: 'Zaloguj się, aby zapraszać znajomych i dostawać część z ich dropów. Tutaj pojawi się twój link polecający.',
    paymentTitle: 'Doładowanie salda',
    paymentReason: 'Zaloguj się, aby doładować saldo SHOT i otwierać skrzynki, robić kontrakty i upgrade’y.',
    caseOpenTitle: 'Otwórz skrzynkę',
    caseOpenReason: 'Zaloguj się, aby otwierać skrzynki. Wygrane przedmioty od razu trafią do twojego ekwipunku.',
    caseBattleCreateTitle: 'Utwórz Case Battle',
    caseBattleCreateReason: 'Zaloguj się, aby wyzwać znajomych na Case Battle. Wejście opłacasz monetami — najcenniejszy drop zgarnia wszystko.',
    rushMidTitle: 'Rush Mid',
    rushMidReason: 'Zaloguj się, aby grać w Rush Mid — turowe mecze PvP z graczami na tym samym bilecie.',
    rushMidSurveyTitle: 'Ankieta o Rush Mid',
    rushMidSurveyReason: 'Zaloguj się, aby wypełnić ankietę o Rush Mid i pomóc ulepszyć grę.',
    rouletteTitle: 'Ruletka',
    rouletteReason: 'Zaloguj się, aby zagrać w ruletkę — jedna runda, jedna pula, równe szanse dla wszystkich.',
    bandTitle: 'SHOT BAND',
    bandReason: 'Zaloguj się, aby dołączyć do SHOT BAND — klubu z cashbackiem, codziennymi zadaniami i cotygodniowym losowaniem noża.',
  },
});
